import React, { useEffect, useState } from 'react'
import { Button, Modal } from 'antd'
import { useTranslation } from 'react-i18next'
import {
  ErrorNotificationItem,
  errors_store,
  removeErrorFromList,
} from '../errors-store'
import { tryToGetErrorMessage } from '../try-to-get-error-message'
import { CloseOutlined } from '@ant-design/icons'

export const GlobalErrorNotificationModal = () => {
  const { t } = useTranslation()

  const [errorsList, setErrorsList] = useState<ErrorNotificationItem[]>([])

  useEffect(() => {
    return errors_store.subscribe((data) => {
      setErrorsList(data.errors)
    })
  }, [])

  const currentErrorOnView = errorsList?.[0] || null

  const onCloseModal = () => {
    if (currentErrorOnView?.id) {
      removeErrorFromList(currentErrorOnView.id)
    }
  }

  if (!currentErrorOnView) return null

  return (
    <Modal
      width={550}
      open={true}
      footer={null}
      key={currentErrorOnView.id}
      closeIcon={<CloseOutlined onClick={() => onCloseModal()} />}
      onCancel={() => onCloseModal()}>
      <div>
        <div>
          <h5
            style={{
              fontSize: '26px',
              fontWeight: '600',
              color: '#ff4d4f',
              textAlign: 'center',
            }}>
            {t('errors.notification.title')}
          </h5>
          <p
            style={{
              fontSize: '17px',
              textAlign: 'center',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
            }}>
            {tryToGetErrorMessage(currentErrorOnView.original)}
          </p>
          {/* <p
            style={{
              fontSize: '13px',
              textAlign: 'center',
            }}>
            {t('errors.notification.hint')}
          </p> */}
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
          }}>
          <Button
            type="default"
            danger
            style={{
              minWidth: '200px',
            }}
            onClick={onCloseModal}>
            {t('errors.notification.actionText')}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
